import { ShadowStyles, HStack as NBHStack, Stack as NBStack, VStack } from '@genial/components';
import { Color, Spacing } from '@genial/design-tokens';
import { Box } from 'native-base';
import React, { useMemo } from 'react';

import { Hello } from './components/Hello';
import { ValueDisplayToggle } from './components/ValueDisplayToggle';

interface HeaderProps {
  isMobile?: boolean;
}

export const Header: React.FC<HeaderProps> = ({ isMobile }) => {
  const content = useMemo(() => {
    let stack: JSX.Element;

    if (isMobile) {
      stack = (
        <>
          <NBHStack>
            <Hello isMobile={isMobile} />
            <ValueDisplayToggle isMobile={isMobile} color={Color['neutral.medium']} />
          </NBHStack>
        </>
      );
    } else {
      stack = (
        <>
          <Hello isMobile={isMobile} />
          <ValueDisplayToggle isMobile={isMobile} color={Color['neutral.white']} />
        </>
      );
    }

    return stack;
  }, [isMobile]);

  return (
    <VStack>
      <NBStack
        direction={{ base: 'column', sm: 'row' }}
        paddingTop={{ base: Spacing['stack.xxs'], sm: Spacing['stack.xxs'] }}
        paddingBottom={{ base: Spacing['stack.xxs'], sm: 0 }}
        paddingX={{ base: Spacing['stack.xxxs'], sm: Spacing['stack.xxs'] }}
        space={Spacing['stack.xxs']}
        alignItems={isMobile ? 'space-between' : 'center'}
        justifyContent={isMobile ? 'space-between' : 'flex-start'}>
        {content}
      </NBStack>
      {isMobile && (
        <Box overflow="hidden" height={5} justifyContent="flex-end">
          <Box
            style={{ ...ShadowStyles.Level[1] }}
            backgroundColor={Color['neutral.white']}
            borderTopRadius="full"
            height={4}
            overflow="hidden"
          />
        </Box>
      )}
    </VStack>
  );
};
